module.exports = __webpack_public_path__ + "img/CM_DRAGON.467f6e1b.png";